/**
 * Referral valid origins and their matching regex from pathname.
 * Code is replicated in `www/www/public/js/pages/estima.js` and `MALegacy/share/ui.estima.inc`, don't forget to maintain both.
 * @type {Object}
 */
const ORIGINS = {
    blog: /^\/wikimmo\//i,
    page_prix: /^\/prix-immobilier\//i,
    estima_landing: /^\/estimation-immobiliere(-new)?\/$/i,
    estima_semantic_cocoon: /^\/estimation-immobiliere\/.+/i,
    myaccount: /^\/mon-compte\//i,
    homepage: /^\/$/i,
};

/**
 * Retrieve search params from `window.location` and structure them in a key/value Map.
 * @return {Object} Key/value map containing all search params.
 */
export function getSearchParamsAsObject() {
    return window.location.search
        .replace(/^\?/, '')
        .split('&')
        .reduce((previous, current) => {
            if (current !== '') {
                const param = current.split('=');
                // eslint-disable-next-line no-param-reassign
                previous[param[0]] =
                    param.length > 1 ? decodeURIComponent(param[1].replace(/\+/g, ' ')) : true;
            }

            return previous;
        }, {});
}

/**
 * Determine referrer origin from search params and `document.referrer` attribute.
 * If `referrer` params is set, param is used. Otherwise, browser
 * referrer is used by matching it against known values.
 * @return {String} Valid referrer origin or empty string
 */
export function referrerOrigin(params) {
    if (params && params.referrer) {
        return params.referrer;
    }

    if (document.referrer.startsWith(window.location.origin)) {
        let referrer;

        if (URL) {
            referrer = new URL(document.referrer).pathname;
        } else {
            referrer = document.referrer.replace(window.location.origin, '').split('?')[0];
        }

        const matching = Object.keys(ORIGINS).filter((o) => ORIGINS[o].test(referrer));
        if (matching.length === 1) {
            return matching[0];
        }
    }

    return 'external';
}
